package com.downdogapp.client.controllers

import com.downdogapp.client.FaqItem
import com.downdogapp.client.FaqItem.*
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.*
import com.downdogapp.client.api.FeedbackType.*
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.SupportView

class SupportViewController : ViewController() {

  override val view = SupportView(this)

  fun submitFeedback(feedbackType: FeedbackType, feedbackContent: String, callback: (Boolean) -> Unit) {
    Network.post(
      RecordFeedbackRequest(
        feedbackType = feedbackType,
        text = feedbackContent
      )
    ) {
      callback(it != null)
    }
  }

  companion object {

    fun getRelevantFAQs(feedbackType: FeedbackType): List<FaqItem> =
      when (feedbackType) {
        AFFORDABILITY, FREE_FOR_SCHOOLS, OTHER -> listOf()

        ACCOUNT_AND_LOGIN_ISSUES ->
          listOf(
            CANT_ACCESS_SUBSCRIPTION,
            HOW_TO_CANCEL,
            AUTO_RENEW_OFF,
            CHANGE_EMAIL,
            CHANGE_PASSWORD,
            UNLINK_GOOGLE_FACEBOOK,
            DELETE_ACCOUNT,
            CANNOT_MERGE_ACCOUNTS,
            ALL_APPS_PURCHASE,
            MANAGE_EMAIL_PREFERENCES,
            FAMILY_SHARING,
            RECEIPTS,
            GIFT
          )

        BILLING ->
          listOf(
            CANT_ACCESS_SUBSCRIPTION,
            HOW_TO_CANCEL,
            AUTO_RENEW_OFF,
            SALE_PRICE,
            PAYMENT_METHODS,
            NO_PARTIAL_REFUND,
            SUBSCRIPTION_RENEWAL_PRICE,
            MONTHLY_TO_YEARLY,
            ALL_APPS_PURCHASE,
            PRICE_DIFFERENCE,
            NOT_FREE,
            NO_EXCHANGE_FEES,
            MEMBERSHIP_DELAYED_START,
            FAMILY_SHARING,
            RECEIPTS,
            GIFT,
            LIFETIME,
            AFFILIATE
          )

        TECH_ISSUES ->
          listOf(
            CANT_ACCESS_SUBSCRIPTION,
            MUSIC_VOLUME_VS_VOICE,
            NO_SOUND,
            TURN_OFF_MUSIC,
            CHANGE_LANGUAGE,
            VIDEO_FREEZING,
            NIDRA_AUDIO_ONLY,
            VIDEO_ACCIDENTALLY_MIRRORED,
            CAST,
            CAST_TROUBLESHOOTING,
            GOOGLE_FIT,
            APPLE_HEALTH,
            FITBIT,
            CANNOT_MERGE_ACCOUNTS
          )

        FEATURE_REQUEST ->
          listOf(
            MUSIC_VOLUME_VS_VOICE,
            EXCLUDE_POSES,
            INCLUDE_POSES,
            SAVE_FOR_OFFLINE,
            CAST,
            SHARE_PRACTICE,
            SAVE_TO_FAVORITES,
            RENAME_FAVORITES,
            SUBTITLES,
            VIEW_PLAYLIST,
            GUIDED_MEDITATION_AND_BREATHING,
            GOOGLE_FIT,
            APPLE_HEALTH,
            FITBIT,
            AFFILIATE
          )

        EXERCISE_ADVICE ->
          listOf(
            SETTINGS_FOR_BEGINNERS,
            LEVEL,
            SLOWER_PACE,
            EXCLUDE_POSES,
            INCLUDE_POSES,
            GUIDED_MEDITATION_AND_BREATHING,
            YOGA_NIDRA_INFO,
            PRENATAL,
            MAXIMUM_VERBOSITY
          )

        PRACTICE_FEEDBACK ->
          listOf(
            MUSIC_VOLUME_VS_VOICE,
            SLOWER_PACE,
            MAXIMUM_VERBOSITY,
            MINIMUM_VERBOSITY,
            EXCLUDE_POSES,
            INCLUDE_POSES,
            SAVE_FOR_OFFLINE,
            GUIDED_MEDITATION_AND_BREATHING,
            NIDRA_AUDIO_ONLY,
            CHANGE_PLAYLIST_TYPE,
            TURN_OFF_MUSIC,
            CHANGE_VOICE,
            CHANGE_LANGUAGE,
            PRENATAL,
            POSE_LIBRARY,
            VIDEO_MODEL
          )
      }
  }

  fun getRefundablePayment(callback: (LatestPaymentResponse?) -> Unit) {
    Network.post(LatestPaymentRequest()) {
      callback(it?.let { LatestPaymentResponse.fromJson(it) })
    }
  }

  fun issueRefund(paymentId: String, callback: (Boolean) -> Unit) {
    Network.post(IssueRefundRequest(paymentId = paymentId)) {
      callback(it != null)
    }
  }
}
